import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Services from '@/components/Services';
import PhotoGallery from '@/components/PhotoGallery';
import VideoGallery from '@/components/VideoGallery';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import FloatingContact from '@/components/FloatingContact';

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <PhotoGallery />
      <VideoGallery />
      <ContactForm />
      <Footer />
      <CookieConsent />
      <FloatingContact />
    </div>
  );
};

export default Index;
